import React, { useEffect, useContext, useState, useRef } from "react";
import styles from "./HeaderTimeDetails.module.scss";
import { getCookie } from "../../../utils/utils";
import MicroserviceFetchUtil from "../../../common/microservice-fetch-util";
import { StoreContext } from "../../../components/ContextStore/StoreContextProvider";
import imagePaths from "../../../constants/imagePaths";
import Select from "react-select";
import { getMonthOptions } from "../../../helper/dateHelper";
import GaEventHelper from "../../../helper/ga-event-helper";
import { GA_EVENTS } from "../../../common/gaEventConstants";
import { useHistory } from "react-router-dom";
import { handleChange as handleChangeHelper, setDropdownValue } from "../../../helper/refreshDateHelper";
import { DropdownContext } from "./DropdownContext";

const HeaderTimeDetails = ({ selectedValue, setSelectedValue, isLocateView = false }) => {
  const { common } = imagePaths;
  const history = useHistory();
  const { selectedCountryCode, userDetails } = useContext(StoreContext);
  const { isPerfectStoreTab } = useContext(DropdownContext);
  const [noOfDays, setNoOfDays] = useState(0);
  const [noOfWorkingDays, setNoOfWorkingDays] = useState(0);
  const [options, setOptions] = useState(() => getMonthOptions(selectedCountryCode, userDetails, isPerfectStoreTab));
  const pendingRequestRef = useRef(null);

  const handleChange = (e) => {
    handleChangeHelper(e, {
      userDetails,
      history,
      setSelectedValue,
      GA_EVENTS,
      GaEventHelper,
    });
  };

  useEffect(() => {
    setOptions(getMonthOptions(selectedCountryCode, userDetails, isPerfectStoreTab));
  }, [selectedCountryCode, userDetails, isPerfectStoreTab]);

  useEffect(() => {
    const selectedOption = options.find((option) => option.value === selectedValue);
    if (selectedOption) {
      localStorage.setItem("selectedDropdownLabel", selectedOption.label);
      setDropdownValue(localStorage.getItem("selectedDropdownLabel"));
    }
  }, [selectedValue, options]);

  useEffect(() => {
    if (!selectedCountryCode || !userDetails?.role) return;
    const month =
      selectedValue === "PreviousMonth"
        ? userDetails?.previousMonth
        : userDetails?.currentMonth;
    const getIdToken = getCookie("idToken");
    if (!getIdToken) return;
    const url =
      selectedCountryCode === "pk"
        ? `salesman/workingdays?startDate=${month?.monthStartDate || ""}&endDate=${month?.monthEndDate}`
        : "salesman/workingdays";

    if (pendingRequestRef.current === url) return;
    pendingRequestRef.current = url;

    MicroserviceFetchUtil.get(url, {
      customerToken: getIdToken,
      countryCode: selectedCountryCode,
    })
      .then((data) => {
        if (data && data.statusCode === 200 && data.statusMessage === "SUCCESS") {
          setNoOfDays(data["response-data"].NoOfDaysPassed);
          setNoOfWorkingDays(data["response-data"].TotalNoOfWorkingDays);
        }
      })
      .catch((error) => {
        console.error("Error fetching working days", error);
      });
  }, [selectedCountryCode, selectedValue, userDetails]);

  const daysPercentage = noOfWorkingDays > 0 ? Math.round((noOfDays * 100) / noOfWorkingDays) : 0;

  // For /locate path, use fixed "Today" option
  let locateOptions = options;
  let locateValue = options.find((item) => item.value === selectedValue);
  let locateIsDisabled = false;
  let locateComponents = {};

  if (isLocateView) {
    locateOptions = [{ value: "day", label: "Today" }];
    locateValue = { value: "day", label: "Today" };
    locateIsDisabled = true;
    locateComponents = { DropdownIndicator: () => null };
  }

  return (
    <div className={styles.headerTimeDetails}>
      {noOfWorkingDays > 0 && (selectedValue === "mtd" || isLocateView) && (
        <p className={styles.timeElapsed}>
          <span className={styles.timeElapsedLabel}>Total Time Elapsed</span>
          <span className={styles.timeElapsedValue}>{`${noOfDays}/${noOfWorkingDays} days (${daysPercentage}%)`}</span>
        </p>
      )}
      <div className={styles.buttons}>
        <div className={styles.dropdownContainer}>
          <Select
            options={locateOptions}
            placeholder={
              selectedValue === "day"
                ? "Today"
                : options.find((item) => item.value === selectedValue)?.label
            }
            onChange={(e) => !isLocateView && handleChange(e)}
            key={selectedValue}
            value={locateValue}
            isSearchable={false}
            isDisabled={locateIsDisabled}
            components={locateComponents}
            classNames={{
              container: () => styles.dropdown,
              control: () => styles.dropdownControl,
              valueContainer: () => styles.dropdownControl,
              input: () => styles.dropdownInput,
              singleValue: () => styles.dropdownText,
              placeholder: () => styles.dropdownText,
              indicatorSeparator: () => styles.seperator,
              dropdownIndicator: () => styles.dropdownArrow,
              menu: () => styles.dropdownMenu,
              menuList: () => styles.dropdownMenuList,
              option: (state) => state.isFocused || state.isSelected ? styles.dropdownOptionFocused : styles.dropdownOption,
            }}
            menuPortalTarget={document.body}
            styles={{
              control: (base) => ({ ...base, minHeight: 'unset', border: 'none', boxShadow: 'none', backgroundColor: 'transparent' }),
              valueContainer: (base) => ({ ...base, padding: 0 }),
              menu: (base) => ({ ...base, margin: 0, marginTop: '4px' }),
              menuList: (base) => ({ ...base, padding: 0 }),
              menuPortal: (base) => ({ ...base, zIndex: 1000 }),
              option: (base) => ({ ...base, backgroundColor: 'transparent', color: 'inherit', padding: 0, cursor: 'pointer' }),
              dropdownIndicator: (base) => ({ ...base, padding: '0 8px' }),
              indicatorSeparator: () => ({ display: 'none' }),
            }}
          />
          <img src={common.icons.calendar} alt="Calendar" className={styles.calendarIcon} />
        </div>
      </div>
    </div>
  );
};

export default HeaderTimeDetails;
